import { Component, ElementRef, HostListener, OnInit, OnDestroy, AfterContentInit, Inject, NgZone, Renderer2, RendererFactory2, DOCUMENT, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavParams } from 'src/app/components/ionic-replacements/NavParams';
import { ModalController } from 'src/app/components/ionic-replacements/ModalController';
import { ToastController } from 'src/app/components/ionic-replacements/ToastController';
import { LoadingController } from 'src/app/components/ionic-replacements/LoadingController';
import { OrderDetailsProvider } from 'src/app/providers/order-details/order-details';

import { TouchcrApiShippingProvider } from 'src/app/providers/TouchcrApiShippingProvider';
import { UrlsProvider } from 'src/app/providers/urls'
import { TouchcrApiOrderformProvider } from 'src/app/providers/touchcr-api-orderform/touchcr-api-orderform';
import { GeneralProvider } from 'src/app/providers/general';
import { SpinnerProvider } from 'src/app/providers/spinner/spinner';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { TouchcrApiGeneralExtenderProvider } from 'src/app/providers/touchcr-api-general/touchcr-api-general-extender'
import { TouchcrApiOrderExtenderProvider } from 'src/app/providers/touchcr-api-order/touchcr-api-order-extender'
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { PaypalPaymentExtenderProvider } from 'src/app/providers/paypal/paypal-extender'
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { CalculateProvider } from 'src/app/providers/calculate/calculate';
import { StateProvider } from 'src/app/providers/state';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings'
import { ModalProvider } from 'src/app/providers/modal/modal';

import { DynamicCurrencyPipe } from 'src/app/shared/pipes/dynamic-currency.pipe';
import { Location } from '@angular/common';
import { PageContentBuilderService } from 'src/app/services/pageContents.service';
import { MultiUpsellProductFactory } from 'src/app/services/multi-upsell-product-factory.service';
import { PixelInjectionService } from 'src/app/services/pixel-injection.service';
import { UpsellDebugService } from 'src/app/services/upsell-debug.service';
import { UpsellAnalyticsService } from 'src/app/services/upsell-analytics.service';
import { UpsellFunnelNavigationService } from 'src/app/services/upsell-funnel-navigation.service';
import { UpsellProduct } from 'src/app/models/upsellProduct';
import { InfoUpsellProduct } from 'src/app/models/infoUpsellProduct';
import { Order } from 'src/app/models/order';
import { Units } from 'src/app/models/units';
import { ProductOption } from 'src/app/models/productOption';
import { MultiSelectorEventData } from 'src/app/models/multiSelectorProduct';
import { PostPurchaseProduct } from 'src/app/models/postPurchaseProduct';
import { DefaultFunnel } from 'src/app/models/defaultFunnel';
import { Names } from 'src/app/models/names';
import { UndressedProduct } from 'src/app/models/undressedProduct';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from 'src/app/models/state';
import { BRAND_BASE_URL, CDN_IMAGES } from 'src/constants/param-constants';

const MESSAGE_TO_REDIRECT_TO_LAST_PAGE = 'Proceed to the thank you page';
const BRAND = (window as any)['process_env'].BRAND;

@Component({
    selector: 'app-us-generic',
    templateUrl: './us-generic.component.html',
    styleUrls: ['./us-generic.component.scss'],
    standalone: false
})
export class USGenericComponent implements OnInit, OnDestroy, AfterContentInit {
  firstName: string = '';

  public optionsNames = [
    "Beef",
    "Chicken",  
    "Salmon",
    "Variety"
  ];
  public productQuantity: number;
  public productQuantityNextUp: number;

  /**Multiselector Variables */
  public displayedProducts: UpsellProduct[] = [];

  public currentStep: number;
  public undressedProducts: Record<string, UndressedProduct>;
  public productInfoFromFunnelConfig: DefaultFunnel[];
  private routeDataProcessed: boolean = false;

  public dynamicCurrencyPipe: DynamicCurrencyPipe = new DynamicCurrencyPipe();

  // ============================================================================
  // Merged from former UpsellFunnelSettingsBase (collapsed inheritance layer)
  // ============================================================================

  /** Data object used to tokenize a Braintree payment */
  braintreeTokenizePaymentData: any;

  /** PayPal payment ID for the transaction */
  paypalpaymentId: string;

  /** Client token received from Braintree for authentication */
  braintreeClientToken: any;

  /** Whether to display the PayPal payment button */
  showPayPalPayButton: boolean;

  /** Default country code for Braintree payments */
  braintreeDefaultCountry: string;

  /** Language translation ID for Braintree UI */
  // braintreeLanguageTranslation: number;

  /** Whether Braintree payment integration is enabled */
  braintreeEnabled: boolean;

  /** Whether this is a subscription payment */
  // isSubscription: boolean;

  /** Whether Braintree A/B testing is enabled */
  braintreeSplitTesting: boolean;

  /** Instance of the Braintree client */
  braintreeInstance: any;

  /** Whether Braintree is currently loading */
  isBraintreeLoading: boolean;

  /** Instance of PayPal checkout via Braintree */
  paypalCheckoutInstance: any;

  /** Whether to hide the PayPal button */
  hidePaypalButton: boolean;

  /** Tokenized payment data from Braintree PayPal flow */
  braintreePayPalTokenizedPayment: any;

  /** Whether to use updated Braintree UI styles */
  useNewBraintreeStyles: boolean;

  /** Customer email from Braintree PayPal flow */
  braintreePayPalEmail: string;

  /** Whether Braintree Drop-in UI is valid */
  braintreeDropinValid: boolean;

  /** Whether to hide PayPal button in Braintree flow */
  braintreeHidePayPalButton: boolean;

  /** Whether CB2 payment option is selected */
  isSelectedCB2: boolean;

  /** Whether using common checkout terms & conditions */
  isCheckoutCommonTC: boolean;

  /** Callback to handle CB2 state changes */
  changeStateCB2: () => void;

  /** Payment method nonce from Braintree */
  braintreeNonce: string;

  /** DOM element for payment overlay */
  overlayDiv: any;

  braintreeCurrencyConversion: number = 1; // TOUC-14710
  officialCurrency: string = 'USD';
  currencySymbol: string = "$"; // TOUC-14710
  currency: string = 'USD'; // TOUC-14710

  // --- Merged from former UpsellBase (Phase 3) ---
  orderDetailsInfo: any = {};
  order: any = {};
  upsell: any = {};
  paymentMethod: {
    standard: boolean,
    googlePay: boolean,
    applePay: boolean,
    paypal: boolean,
    braintreeMethod: boolean
  } = {
    standard: false,
    googlePay: false,
    applePay: false,
    paypal: false,
    braintreeMethod: false
  };
  urlParameters: any = {};

  // country list variables
  countries: any = {};
  statesList: any = [];

  // tax service variables
  dataForTax: any = {};
  taxRate: any = {};
  taxAmount: number = 0;
  taxServiceEnabled: boolean = (window as any)['process_env'].IS_ENABLED_SALESTAX;
  isErrorTax: boolean = false;
  isTaxValid: boolean = true;

  upsellIndex: number = -1;
  upsellsArray: Array<any> = [{}];
  purchasedUpsells: Array<any> = [];
  isAmazonEnabled: boolean = (window as any)['process_env'].AMAZON_IS_ENABLED;
  isAmazon: boolean = false;
  isAmazonScriptLoaded: boolean = false;

  // Need for creating invoice in shipping service
  productsForShipping: Array<any> = [];
  accountInfoForShipping: any = {};
  selectedDeliveryDay: any;
  plannedLeavePage: boolean = false;
  isShippingAvailable: boolean = (window as any)['process_env'].SHIPPING;
  isShippingValid: boolean = true;

  // transaction fee
  transactionFeeAmount: number = 0;
  transactionFeeEnabled: boolean = (window as any)['process_env'].IS_ENABLED_TRANSACTION_FEE;
  isCalculatingTransactionFee: boolean = false;
  disableCardPaymentDueToTransactionFee: boolean = false;
  orderSTxId: string = '';  // order Id in surchx

  state: State;

  public customCssPath: string = '';

  orderProducts: any[] = [];
  totalTax: number = 0;
  exitpop: any = false;
  spintest: any = false;
  buttonList: any = [
    {
      buttonId: 'AmazonPayButton',
      walletId: 'walletWidgetDiv',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton1',
      walletId: 'walletWidgetDiv1',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton2',
      walletId: 'walletWidgetDiv2',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton3',
      walletId: 'walletWidgetDiv3',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton4',
      walletId: 'walletWidgetDiv4',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton5',
      walletId: 'walletWidgetDiv5',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton6',
      walletId: 'walletWidgetDiv6',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton7',
      walletId: 'walletWidgetDiv7',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton8',
      walletId: 'walletWidgetDiv8',
      isPlaceOrder: true,
    },
    {
      buttonId: 'AmazonPayButton9',
      walletId: 'walletWidgetDiv9',
      isPlaceOrder: true,
    }
  ];

  // Global
  productBrand: string = 'Dr. Marty';
  productTitle: string;
  productName: string;
  productNameAlternate: string;
  productImage: string;
  productUnitType: string;
  productUnitTypeNextUp: string;
  initialProduct: string;

  section01Data: any;
  section02Data: any;
  section03Data: any;

  bannerText: string = '';
  bannerImage: string = '';

  // Product
  productRegularPrice: number;
  productYourPrice: number;
  productInstantSavings: number;
  productPercent: number;
  product_box_yourPriceText: string = ""
  product_box_instantSavingsText: string = ""
  product_box_regularText: string = ""

  regularPriceConverted: string;
  instantSavingsConverted: string;
  yourPriceConverted: string;

  // Header
  icon: string = '';
  phone: string = '';
  phoneIcon: string = '';
  dynamicPhoneNumber: string;
  dynamicCustomerServiceHours: string;

  // Product box
  productBoxTitle: string = '';
  productBoxSubtitle: string = '';
  buttonYesText: string = `YES I WANT THIS SPECIAL ADDED TO MY ORDER`;
  buttonNoText: string = `NO THANKS, I UNDERSTAND THAT I WON'T SEE THIS OFFER AGAIN`;
  productBoxCTA: boolean = false;
  mbgCTA: boolean = false;
  mbgText: string = '';
  upsellWhyContent: Array<{id?: string | number, question: string, answer: string}> = [];
  upsellFaqContent: Array<{id?: string | number, question: string, answer: string}> = [];
  upsellWhyImage: string = '';
  guaranteeCopy: string = '';
  guaranteeImage: string = '';
  waitTitle: string = '';
  waitDescription: string = '';
  waitIcon: string = '';

  // Vidalytics
  // vidalyticsConfig: IVidalytics = {
    // vidalyticsEmbedId: '',
    // vidalyticsEmbedIdMobile: ''
  // };

  isStorageAvailable: boolean = true;

  initTimer: any = new Date().getTime(); // TOUC-982
  scrollEvents: any = 0; // TOUC-982
  pageContents: Array<IPageContent>;

  mintercnt = 0; //TOUC-1202

  beforeunloadHandler: any; // TOUC-1251
  visibilityStateChangeHandler: any;
  saveduserHandler: any;
  confirmationMessage: string = 'It looks like you have been editing something. ';
  plannedNav: boolean = false;

  vidalyticsEmbedId: string;
  vidalyticsEmbedIdMobile: string;

  originalPurchaseQuantity: number;
  priceWithTax: boolean = false;

  public randomVariant: number = -1;

  constructorInitialized: boolean = false;

  public isMultiUpsell: boolean = false;

  public route: ActivatedRoute = inject(ActivatedRoute);
  private readonly multiUpsellFactory = inject(MultiUpsellProductFactory);
  private readonly pixelService = inject(PixelInjectionService);
  private readonly debugService = inject(UpsellDebugService);
  private readonly analyticsService = inject(UpsellAnalyticsService);
  private readonly funnelNavService = inject(UpsellFunnelNavigationService);
  private readonly destroyRef = inject(DestroyRef);
  /**Multiselector Variables */
  public multiUpsellProducts: UndressedProduct[] = [];
  public productQuantityPack: number = 1;

  // Prevent flicking by ensuring data is ready before calling the page init routine
  async ngOnInit() {
    await this.resolveFirstName();
    await this.initUpsellPage();
  }

  // Resolve the customer's first name from persisted state (once) to prevent flicking.
  private async resolveFirstName() {
    if (!this.firstName) {
      const response = await this.stateProvider.get();
      const fullName = response?.orderDetails?.order?.customerName;

      if (fullName) {
        this.firstName = fullName.split(' ')[0];
      } else {
        console.warn("No customerName found in orderDetails");
        this.firstName = "";
      }
    }
  }

  constructor(
    public navCtrl: NavControllerExt,
    public navParams: NavParams,
    public tcrApi: TouchcrApiGeneralExtenderProvider,
    public tcrApiOrder: TouchcrApiOrderExtenderProvider,
    public loadingCtrl: LoadingController,
    public eventStreamer: EventStreamerProvider,
    public orderDetails: OrderDetailsProvider,
    public paypalPayment: PaypalPaymentExtenderProvider,
    public toastCtrl: ToastController,
    public ngZone: NgZone,

    public shippingProvider: TouchcrApiShippingProvider,
    public tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public calculateHelper: CalculateProvider,
    public urlsHelper: UrlsProvider,
    public stateProvider: StateProvider,
    public tcrApiOrderform: TouchcrApiOrderformProvider,
    public funnelProvider: FunnelSettingsProvider,
    public generalProvider: GeneralProvider,
    public spinner: SpinnerProvider,
    public modal: ModalController,
    public modalService: ModalProvider,
    public elementRef: ElementRef,
    public renderer: Renderer2,
    @Inject(DOCUMENT) public document: Document,
    public rendererFactory: RendererFactory2,
    private contentBuilder: PageContentBuilderService,
    private location: Location,
    private router: Router,
  ) {
    this.urlParameters = urlsHelper.getDataFromUrl(window.location.search);
    this.urlParameters.brand = BRAND;

    this.renderer = this.rendererFactory.createRenderer(null, null);

    if (!(window as any)['windowInitialized'] && !this.constructorInitialized) {
      (window as any)['windowInitialized'] = true;
      this.constructorInitialized = true;
      try {
        let il = 0;
        let dc = sessionStorage.getItem('braintreeDefaultCountry');
        setTimeout(() => {
          delete (window as any)['windowInitialized'];
        }, 1000);
        // TODO https://support.google.com/translate/thread/260113430/google-translate-script-on-website-for-comercial-use?hl=en
        if (sessionStorage.getItem('braintreeLanguageTranslation') == 'true' && dc) {
          if (this.urlsHelper.getParameterFromUrl({ url: window.location.search, parameter: 'step' }) != '2') {
            setTimeout(() => {
              this.toastCtrl.create({ message: `Translating...`, duration: 1000, position: 'top', cssClass: 'successToast' });
              this.spinner.enable('Translating...');
              setTimeout(() => {
                this.spinner.disable();
              }, 1000);
            }, 150);
          }
          if (!document.querySelector('#google_translate_script')) {
            // get ready for the translation
            let sty = document.createElement('style');
            sty.id = 'google_translate_content_delay';
            sty.innerHTML = `.spinnerInformation, .upsellDownsell {
            animation:0.5s ease 1s normal forwards 1 fadein;
            -webkit-animation:0.5s ease 1s normal forwards 1 fadein;
            opacity:0;
            }
            @keyframes fadein{from{opacity:0}
              to{opacity:1}
            }
            @-webkit-keyframes fadein{from{opacity:0}
              to{opacity:1}
           }
          `;
            document.head.appendChild(sty);
            if (dc == 'United States') il = 1;
            else if (dc == 'France') il = 2;
            else if (dc == 'Germany') il = 3;
            else if (dc == 'Portgual') il = 4;
            else if (dc == 'Brazil') il = 4;
            else if (dc == 'Mexico') il = 5;
            let langstr = 'en,fr,de,pt,es';
            console.log('[GH] setting google translate to ' + dc + ' ' + il, langstr);
            let gscript = document.createElement('script');
            gscript.type = 'text/javascript';
            document.cookie = 'googtrans=;expires=Thu, 01-Jan-70 00:00:01 GMT;';
            gscript.innerText = `function googleTranslateElementInit() {
              if(document.querySelector('.spinnerWheel')) {
                console.log('notranslate spinnerWheel');
                document.querySelector('.spinnerWheel').classList.add('notranslate');
              }
              new google.translate.TranslateElement({ pagelLanguage: "en", includedLanguages: "${langstr}", layout: google.translate.TranslateElement.InlineLayout}, 'google_translate_element');
              var gtint = setInterval(() => {
                console.log('[GH] checking for google translate',document.querySelector('.goog-te-combo').options.length);
                if(  document.querySelector('.goog-te-combo') && document.querySelector('.goog-te-combo').options.length >= 5) {
                  window.clearInterval(gtint);
                    console.log('[GH] inside setting google translate to ${il}', document.querySelector('.goog-te-combo'));
                    document.querySelector('.goog-te-combo').options.selectedIndex = ${il};
                    document.querySelector('.goog-te-combo').dispatchEvent(new Event('change'));
/*                   setTimeout(() => {
                    document.querySelectorAll('.skiptranslate')[1].classList.toggle('skiptranslate_slideup');
                    document.querySelector('#spinner-specific-styles').nextSibling.classList.toggle('hidden');
                  }, 3000); */
                }
              }, 10);
              }`;
            document.head.appendChild(gscript);
            let gtscript = document.createElement('script');
            gtscript.id = 'google_translate_script';
            gtscript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            gtscript.type = 'text/javascript';
            document.head.appendChild(gtscript);
          }
        }
      } catch (e) {
        console.log('[GH] unable to add google translate script', e);
      }


      //TOUC-1525
      (window as any)['spintest'] = this.spintest;

      this.urlParameters = urlsHelper.getDataFromUrl(window.location.search);
      this.urlParameters.brand = BRAND;
      //Check if storage is unavailable - TCR
      try {
        sessionStorage.setItem('StorageTest', '');
        sessionStorage.removeItem('StorageTest');
      } catch (e) {
        this.isStorageAvailable = false;
      }

      try { // TOUC-1251 v1.24.9.1
        if (!this.beforeunloadHandler && window.addEventListener) {
          this.visibilityStateChangeHandler = (e: any) => {
            console.log(`Tab state : ${document.visibilityState}`);
            this.analyticsService.sendCustomEvent(`visibilitychange ${document.visibilityState}`, { initTimer: this.initTimer, scrollEvents: this.scrollEvents }, `Tab state : ${document.visibilityState}`);
          };
          window.addEventListener("visibilitychange", this.visibilityStateChangeHandler);
          console.log('added visibilitychange handler');
          this.beforeunloadHandler = (e: any) => {
            if (!this.exitpop) return; //TOUC-1490
            this.analyticsService.sendCustomEvent('beforeunload', { initTimer: this.initTimer, scrollEvents: this.scrollEvents });
            console.log('emitted beforeunload event');
            this.saveduserHandler = () => {
              window.removeEventListener("focus", this.saveduserHandler);
              setTimeout(() => {
                this.analyticsService.sendCustomEvent('saveduser', { initTimer: this.initTimer, scrollEvents: this.scrollEvents });
                console.log('emitted saveduser event');
                this.spinner.disable();
              }, 1000);
            };
            window.addEventListener("focus", this.saveduserHandler);
            console.log('added focus handler');
            if (this.plannedNav) return null;

            (e || window.event).returnValue = this.confirmationMessage;
            return this.confirmationMessage;
          };
          window.addEventListener("beforeunload", this.beforeunloadHandler);
          console.log('added beforeunload handler');
        }
      } catch (e) {
        console.log("unable to setup TOUC-1251 handlers: ", e);
      }

      if (this.randomVariant == -1) this.randomVariant = Math.floor(Math.random() * 2);  // 0 control, 1 variant
      if (this.urlsHelper.getParameterFromUrl({ url: window.location.search, parameter: 'dynamicversion' }) == 'control') this.randomVariant = 0;
      if (this.urlsHelper.getParameterFromUrl({ url: window.location.search, parameter: 'dynamicversion' }) == 'variant') this.randomVariant = 1;


    }
  }

  trackByIndex(index: number, item: any): any {
    if (item.componentName === 'vidalytics-video') {
      return 'vidalytics-video-component';
    }
    // For other components, use index as before
    return index;
  }

  async populatePageData() {
    this.setProductData();

    // Only call updateWithRoutesData if not already called in ngOnInit, this prevents double interpolation and flicking
    if (!this.routeDataProcessed) {
      await this.updateWithRoutesData();
      this.routeDataProcessed = true;
    }

    this.convertedPrices();

    // Build page contents after all data is set. Use setTimeout to prevent flicking during DOM updates
    setTimeout(() => { this.pageContents = this.contentBuilder.buildPageContents(this.pageContents, this);}, 0);

    if (this.isMultiUpsell) {
      await this.setupMultiUpsell();
    }
  }

  private async setupMultiUpsell(): Promise<void> {
    const { defaultFunnels }: { defaultFunnels: DefaultFunnel[] } = this.funnelProvider.getMainFunnelByUID();
    const multiUpsellData = this.multiUpsellFactory.getMultiUpsellFunnels(defaultFunnels, 'step');
    const optionsList = multiUpsellData.repeated;
    this.currentStep = Number(multiUpsellData.repeatedValues[0]) ?? 1;
    this.addQueryParamIfMissing('step', this.currentStep);
    this.productInfoFromFunnelConfig = this.multiUpsellFactory.orderOptions(optionsList, this.optionsNames);
    if (this.multiUpsellProducts?.length > 0) {
      this.multiUpsellProducts[0].units.quantityOptionProduct4 = this.productQuantity !== 3 ? 'bags of each flavor' : 'bag of each flavor';
    }
    this.undressedProducts = this.multiUpsellProducts.reduce((acc, product, index) => {
      const key = `undressedProduct${index + 1}`;
      acc[key] = {
        names: product.names,
        units: product.units,
        displayNames: product.displayNames,
        images: product.images
      };
      return acc;
    }, {} as Record<string, UndressedProduct>);

    await this.updateProducts()
  }

  private addQueryParamIfMissing(paramName: string, value: number): void {
    const currentParams = { ...this.route.snapshot.queryParams };

    if (!currentParams[paramName]) {
      currentParams[paramName] = value;
      const baseUrl = this.location.path(false).split('?')[0];
      const queryString = new URLSearchParams(currentParams).toString();
      this.location.replaceState(`${baseUrl}?${queryString}`);
    }
  }

  async updateWithRoutesData() {
    // Ensure the customer's first name is resolved before route data interpolation.
    await this.resolveFirstName();
    this.applyRouteData();
  }

  private async updateProducts() {
    const { undressedProduct1 } = this.undressedProducts;
    const product1 = this.multiUpsellFactory.createUpsellProduct(
      this.productInfoFromFunnelConfig,
      {
        funnelGroupName: '',
        productNames: undressedProduct1.names,
        units: undressedProduct1.units,
        images: undressedProduct1.images,
        productPage: {
          product1: 0,
          product2: 1,
          product3: 2,
          product4: 3,
        },
        displayName: undressedProduct1.displayNames
      },
      { productQuantity: this.productQuantity, productQuantityPack: this.productQuantityPack }
    );

    if (!this.state.orderDetails) this.state.orderDetails = {};
    if (!this.state.orderDetails.upsells || this.state.orderDetails.upsells.length < 2) {
      const newUpsells = [{
        ...product1,
        ...product1.productOptions[0],
      }];
      // setUpsells expects Order[] but us-generic stores UpsellProduct-shaped
      // entries here — see code-to-review.md (type confusion on state.upsells).
      await this.stateProvider.setUpsells(newUpsells as unknown as Order[]);
      this.state.orderDetails.upsells = newUpsells as unknown as Order[];
    }
    this.displayedProducts = this.state.orderDetails.upsells as unknown as UpsellProduct[];
  }

  changeUpsell(event: MultiSelectorEventData): void {
    this.upsell = {
      product:
      {
        sfid: event.sfid,
        name: event.name,
        description: ""
      },
      offerPrice: event.offerPrice,
      taxCode: event.productTaxCode,
      sfid: event.sfid,
      shippingCost: event.shippingCost || 0,
      standardPrice: event.regularPrice || null,
    };
  }

  // To control if the page closes
  @HostListener('window:beforeunload')
  unloadHandler() {
    if (this.isShippingAvailable && !this.plannedLeavePage) this.createShippingInvoice(true);
  }

  showNextBase(skip:any) {
    for (let index = 0; index < this.buttonList.length; index++){
      this.buttonList[index].isPlaceOrder = true;
    }
    this.upsellIndex++;
    if (this.upsellIndex > this.upsellsArray.length - 1) {
      this.stateProvider.setNameOrderUpsell(this.stateProvider.ORDER_SUCCESS, this.order, this.purchasedUpsells)
        .then(() => {
          this.spinner.enable('Loading page <br> Please wait...');
          this.navCtrl.setRootExt(this.stateProvider.ORDER_SUCCESS, { name: 'Order Success', isUpsell: true }, { taken: true})
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on showNextBase()', error);
              this.spinner.disable();
            });
        })
    } else {
      this.disableCardPaymentDueToTransactionFee = true;
      this.dataForTax = this.getTaxRateForUpsells({ detailsInfo: this.orderDetailsInfo, upsellIndex: this.upsellIndex});
      return this.tcrApiRemoteServices.getTaxRateForUpsell(this.dataForTax, this.state).toPromise()
        .then(taxRate => {
          this.taxRate = taxRate;
          if (this.upsellsArray[this.upsellIndex] && this.upsellsArray[this.upsellIndex].sfid) {
            if (skip && this.upsellsArray[this.upsellIndex] &&
              this.upsellsArray[this.upsellIndex].type === 'Downsell') {
              this.showNextBase(false);
            } else {
              if (this.upsellsArray[this.upsellIndex].type === 'Downsell' &&
                (this.upsellIndex < 1 ||
                  this.upsellsArray[this.upsellIndex].orderNumber !== this.upsellsArray[this.upsellIndex - 1].orderNumber)) {
                this.showNextBase(false);
              } else {
                this.upsell = this.upsellsArray[this.upsellIndex];
                this.calculateTransactionFee();
              }
            }
          } else {
            this.showNextBase(false);
          }
          if (taxRate === 'error') {
            this.isErrorTax = true;
            return Promise.reject({
              message: `Sorry, we couldn't calculate the tax. Your tax amount is $0.`,
            })
          }
          return Promise.resolve();
        });
    }
    return;
  }

  // Create shipping invoice with our API
  createShippingInvoice(closePage: boolean) {
    if (this.state.shippingInfo && this.state.shippingInfo.isValid) {
      this.stateProvider.clearShippingInfo();
      let ordersIds = this.order.id;
      if (this.purchasedUpsells) this.purchasedUpsells.forEach((e1) => {
        // ordersIds.push({ orderId: e1.id });
        ordersIds += ',' + e1.id;
        e1.orderItems.forEach((e2:any) => {
          this.productsForShipping.push({count : e2.quantity, shippingCost: 0, productId : e2.productId});
        });
      });
      const invoiceBody = {
        products: this.productsForShipping,
        accountInfo: this.accountInfoForShipping,
        orderIds: ordersIds, selectedDeliveryDay:
        this.selectedDeliveryDay
      };
      if (closePage) {
        this.shippingProvider.createInvoiceViaXHR(invoiceBody);
      } else {
        this.shippingProvider.createInvoice(invoiceBody).subscribe();
      }
    }
  }

  calculateTransactionFee() {
    const orderCardNicn = this.orderDetailsInfo.order.nicn ? this.orderDetailsInfo.order.nicn : '';
    if (!this.transactionFeeEnabled || orderCardNicn.length < 8 || !this.paymentMethod.standard) {
      this.disableCardPaymentDueToTransactionFee = false;
      this.transactionFeeAmount = 0;
      return;
    }

    this.isCalculatingTransactionFee = true;
    const accountInfo = {
      billingPostalCode: this.orderDetailsInfo.order.billingZip,
      billingCountryCode: this.orderDetailsInfo.order.billingCountry,
    };

    const orderTotal = +(this.upsell.offerPrice + this.upsell.shippingCost + (this.taxRate.totalTax || 0)).toFixed(2);

    this.tcrApiRemoteServices.requestDataForTrFee({
        brand: (window as any)['process_env'].BRAND,
        account: accountInfo,
        orderTotalWithoutFee: orderTotal,
        orderCardNicn: orderCardNicn,
        orderIdTemp: 'upsellOrder',
        orderSTxId: this.orderSTxId,
        orderTotalWithoutFeeSubscription: 0,
        orderIdTempSubscription: '',
        orderSTxIdSubscription: '',
      }
    ).subscribe((res) => {
      this.isCalculatingTransactionFee = false;
      const calculationResponse = res.trFeeResponse.upsellOrder ? res.trFeeResponse.upsellOrder : {};
      this.transactionFeeAmount = calculationResponse.transactionFee ? calculationResponse.transactionFee : 0;
      this.orderSTxId = calculationResponse.sTxId ? calculationResponse.sTxId : '';
      // response also contains: are calculation is valid in 'calculationResponse.isSuccess'
      this.disableCardPaymentDueToTransactionFee = false;
    }, (err) => {
      this.transactionFeeAmount = 0;
      this.isCalculatingTransactionFee = false;
      this.disableCardPaymentDueToTransactionFee = false;
      this.orderSTxId = '';

      console.log('Error on transaction fee in Сalculate Transaction Fee: ', err);
      this.toastCtrl.create({ message: `Error transaction fee calculating!`, position: 'top', showCloseButton: true, cssClass: 'errorToast' })//.present();
    })
  }

  // Transaction Fee 'capture' callout to API
  captureTransactionFee(orderId:any) {
    this.tcrApiRemoteServices.captureTransactionFeeRequest({
        orderBrand: (window as any)['process_env'].BRAND,
        orderMTxId: orderId,
        orderSTxId: this.orderSTxId,
        orderId: orderId,
        subscriptionSFId: '',
        subscriptionSTxId: '',
      }
    ).subscribe(() => {}, (err) => {
      console.log('Error on capture transaction fee for upsell: ', err);
    })
  }

  changePlaceOrder(index:any) {
    for (let i = 0; i < this.buttonList.length; i++){
      if (i === index) this.buttonList[i].isPlaceOrder = false;
      else this.buttonList[i].isPlaceOrder = true;
    }
  }

  similarity(s1: any, s2: any) {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
      longer = s2;
      shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength === 0) {
      return 1.0;
    }
    return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
  }

  editDistance(s1: any, s2: any) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
      var lastValue = i;
      for (var j = 0; j <= s2.length; j++) {
        if (i == 0)
          costs[j] = j;
        else {
          if (j > 0) {
            var newValue = costs[j - 1];
            if (s1.charAt(i - 1) != s2.charAt(j - 1))
              newValue = Math.min(Math.min(newValue, lastValue),
                costs[j]) + 1;
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
      }
      if (i > 0)
        costs[s2.length] = lastValue;
    }
    return costs[s2.length];
  }

  getAlternativeOffer(brokenActual:any) {
    let matchto = brokenActual.substring(0,3);

    console.log("getAlternativeOffer: " + brokenActual);
    console.log("matchto: " + matchto);
    let foundp = false;
    let winner: any = '';
    let winnerPerc = 0;

    if (this.navCtrl.getConfig()) {

      for (let prod = 0; prod < this.navCtrl.getConfig().length; prod++) {

        if (this.navCtrl.getConfig()[prod].path?.startsWith(matchto)) {
          let perc = Math.round(this.similarity(brokenActual, this.navCtrl.getConfig()[prod].path || '') * 10000) / 100;
          if (perc > winnerPerc) {
            winnerPerc = perc;
            winner = this.navCtrl.getConfig()[prod].path;
          }
          foundp = true;
          console.log("found p: " + brokenActual + " and " + this.navCtrl.getConfig()[prod].path + " are similar " + perc + "%");
        }
      }
    }
    if (!foundp) {
      return 'DrMarty_ThankYou_AP';
    }
    return winner;
  }

  showNext(skip: any) {
    this.dataForTax = this.getTaxRateForUpsells({
      detailsInfo: this.orderDetailsInfo,
      upsellIndex: this.upsellIndex,
    });

    this.tcrApiRemoteServices
      .getTaxRateForUpsell(this.dataForTax, this.state)
      .toPromise()
      .then((taxRate: any) => {
        this.taxRate = taxRate;
        if (taxRate === 'error') {
          this.isErrorTax = true;
        }
        this.calculateTransactionFee();
      });
    return;
  }

  async redirectToStep(stepPage: any, noThanksClicked = false) {
    const params = !stepPage ? null : await this.funnelProvider.getPageByStep(stepPage);
    if (!params) return;
    const { component, orderForm, type } = params;
    if (type === 'Upsell' || type === 'DownSell') {
      await this.stateProvider.setUpsells([orderForm]);
    }

    if (noThanksClicked) {
      this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: false })
        .then(() => {
          this.spinner.disable();
        })
        .catch((error) => {
          console.log('Error on noThanks()', error);
          this.spinner.disable();
        });
    } else {
      this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true, alternate: false })
      .then(() => {
        this.spinner.disable();
      })
      .catch((error) => {
        console.log('Error on noThanks()', error);
        this.spinner.disable();
      });
    }


  }

  async handleNoThanks() {
    let stp = this.urlsHelper.getParameterFromUrl({ url: document.location.search, parameter: 'step' })
    if (this.isMultiUpsell) {
      const currentFunnelStep = Number(
        this.urlsHelper.getParameterFromUrl({ url: this.urlsHelper.getQueryParams(), parameter: 'step' }),
      );

      // Use the new method to get the next step for declined upsell
      const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, false);
      return this.redirectToStep(nextStep, true);
    }

    this.spinner.enable('Loading page <br> Please wait...');
    for (let index = 0; index < this.buttonList.length; index++) {
      this.buttonList[index].isPlaceOrder = true;
    }
    const params: any = await this.funnelProvider.getNextPage(undefined, false, this.upsell.type);

    if (!params) {
      setTimeout(() => {
        this.spinner.disable();
      }, 1000);

      if (typeof (window as any)['funnelConfsForUUID'] == 'object') {
        // handle the configuration error
        let brokenfunnel = (window as any)['funnelConfsForUUID'];
        let brokenfunnel_firstUpsell = brokenfunnel.defaultFunnels[stp].variants[0].url;
        let alt = this.getAlternativeOffer(brokenfunnel_firstUpsell);
        if (alt) {
          console.log("redirecting to alternative offer: " + alt);
          //return this.navCtrl.setRootExt(alt, { name: alt},{currentStep: stp, nextStep: (stp+1) });
          //return this.navCtrl.setRootExt(alt, { name: alt});
          return this.navCtrl.setRootExt(alt, { name: alt, isUpsell: true }, { taken: false, alternate: true })
        }
      }

      return this.toastCtrl
        .create({
          message: `Page not found`,
          position: 'top',
          showCloseButton: true,
          cssClass: 'errorToast',
        })
    }
    setTimeout(() => {
      this.spinner.disable();
    }, 1000);
    const { component, orderForm, type } = params;
    if (type === 'Upsell' || type === 'DownSell') {
      await this.stateProvider.setUpsells([orderForm]);
    }
    this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: false })
      .then(() => {
        this.spinner.disable();
      })
      .catch((error) => {
        console.log('Error on noThanks()', error);
        this.spinner.disable();
      });
    return;
  }

  setBraintree(braintreeCurrencyConversion: any, currencySymbol: any) {
    this.braintreeCurrencyConversion = braintreeCurrencyConversion;
    this.currencySymbol = currencySymbol;
  }

  async braintreeGetNonce() {
    return this.paypalCheckoutInstance.tokenizePayment(this.braintreeTokenizePaymentData, (err: any, payload: any) => {
      console.log('[GH] braintree paypal tokenized payment', payload);
      // TOUC-14710 https://developer.paypal.com/braintree/docs/guides/payment-method-nonces
      this.braintreeNonce = payload.nonce;
      console.log('[GH] braintreeNonce ', this.braintreeNonce);
      this.upgradeBraintreeOrder(sessionStorage.getItem('deviceData'));
    });
  }

  showPayPalButtonDialog() {
    // Create overlay div
    this.overlayDiv = document.createElement('div');
    this.overlayDiv.style.position = 'fixed';
    this.overlayDiv.style.top = '0';
    this.overlayDiv.style.left = '0';
    this.overlayDiv.style.width = '100%';
    this.overlayDiv.style.height = '100%';
    this.overlayDiv.style.backgroundColor = 'rgba(0,0,0,0.7)';
    this.overlayDiv.style.zIndex = '9999';

    // Create payment modal
    const modalDiv = document.createElement('div');
    modalDiv.className = 'paypal-modal';
    modalDiv.style.fontFamily = 'Arial, sans-serif';
    modalDiv.style.position = 'fixed';
    modalDiv.style.top = '50%';
    modalDiv.style.left = '50%';
    modalDiv.style.transform = 'translate(-50%, -50%)';
    modalDiv.style.backgroundColor = 'white';
    modalDiv.style.padding = '20px';
    modalDiv.style.borderRadius = '5px';
    modalDiv.style.maxWidth = '400px';
    modalDiv.style.width = '90%';
    modalDiv.style.height = '170px';
    modalDiv.style.position = 'relative';

    const style = document.createElement('style');
    style.textContent = `
      .paypal-button {
        border-radius: 25px !important;
      }
    `;
    document.head.appendChild(style);

    // Create X button in upper right corner
    const closeButton = document.createElement('button');
    closeButton.textContent = '×';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '10px';
    closeButton.style.right = '15px';
    closeButton.style.background = 'none';
    closeButton.style.border = 'none';
    closeButton.style.fontSize = '24px';
    closeButton.style.fontWeight = 'bold';
    closeButton.style.cursor = 'pointer';
    closeButton.style.color = '#666';
    closeButton.style.lineHeight = '1';
    closeButton.style.padding = '0';
    closeButton.style.width = '30px';
    closeButton.style.height = '30px';
    closeButton.style.display = 'flex';
    closeButton.style.alignItems = 'center';
    closeButton.style.justifyContent = 'center';

    // Add hover effect
    closeButton.addEventListener('mouseenter', () => {
      closeButton.style.color = '#000';
    });
    closeButton.addEventListener('mouseleave', () => {
      closeButton.style.color = '#666';
    });

    // Add click event listener to remove overlay
    closeButton.addEventListener('click', () => {
      if (document.body.contains(this.overlayDiv)) {
        document.body.removeChild(this.overlayDiv);
      }
      this.spinner.disable();
    });

    modalDiv.innerHTML = `
      <div style="position: relative">
        <h3 style="margin-top:0; padding-right: 30px;">Payment Required</h3>
        <p>Please complete your payment with PayPal to continue with your order.</p>
        <div style="height: 35px; background: #ffc439; width: 100%; border-radius: 18px; display: flex; align-items: center; justify-content: center; opacity: 0.6;">
          <img style="display:block; margin: auto; height: 18px;" class="paypalBtnPlaceholder" src="/assets/img/paypal-bare.png" alt="PayPal" />
        </div>
        <div id="paypal-button" style="position: absolute; bottom: 0; width: 100%; display: flex;"></div>
      </div>
    `;

    // Append the close button to the modal
    modalDiv.appendChild(closeButton);
    this.overlayDiv.appendChild(modalDiv);
    document.body.appendChild(this.overlayDiv);
  }

  braintreeDisplayHandler() {
    setTimeout(() => {
      this.isBraintreeLoading = false;
    }, 333);
  }

  async setupBraintreeClient() {
    // TOUC-14710
    if (this.braintreeCurrencyConversion) {
      this.showPayPalPayButton = false; // use paypal from braintree

      (window as any)['jwtCallback'] = (data: any) => {
        console.log('[GH] jwt upsell callback ', data);
        this.braintreeClientToken = data['jwt'];
        if (this.braintreeClientToken && this.braintreeClientToken.trim().length > 0) {
          this.showPayPalPayButton = false; // use paypal from braintree
          sessionStorage.setItem('braintreeDefaultCountry', this.braintreeDefaultCountry);
          console.log('[GH] this.currency', this.currency);
          console.log('[GH] this.currencySymbol', this.currencySymbol);
          sessionStorage.setItem('currency', this.currency);
          sessionStorage.setItem('currencySymbol', this.currencySymbol);
          this.braintreeEnabled = true;
          this.braintreepaypalSetup();
          this.showPayPalPayButton = false;

        } else {
          this.showPayPalPayButton = true; // use paypal legacy
        }
      }
      let jwtscript = document.createElement('script');
      jwtscript.src = '/checkout-jwt/?callback=jwtCallback';
      jwtscript.type = 'application/javascript';
      document.body.appendChild(jwtscript);
    }
  }

  tearDownBraintree() {
    this.braintreeCurrencyConversion = 1;
    this.braintreeSplitTesting = false;
    this.currency = 'USD';
    this.currencySymbol = '$'; // TODO get from constants
    this.showPayPalPayButton = true;
    this.braintreeClientToken = null;
    this.braintreeInstance = null;
    this.braintreeEnabled = false;
    this.ngZone.run(() => {
      this.braintreeDisplayHandler();
    });
    sessionStorage.removeItem('currencySymbol');
    sessionStorage.removeItem('currency');
  }

  braintreepaypalSetup() {
    // if ((window as any)['process_env']['BRAINTREE_PAYPAL_ENABLED'] === 'true') {
    // Create a client.
    (window as any)['braintree'].client.create({
      authorization: this.braintreeClientToken,
    }, (clientErr: any, clientInstance: any) => {
      if (clientErr) {
        this.braintreeDisplayHandler();
        console.error('Error creating client:', clientErr);
        return;
      }
      // Create a PayPal Checkout component.
      (window as any)['braintree'].paypalCheckout.create({
        client: clientInstance
      }, (paypalCheckoutErr: any, paypalCheckoutInstance: any) => {
        this.paypalCheckoutInstance = paypalCheckoutInstance;
        let paypalCheckoutInstancePayload = {
          commit: true, // Per Braintree, this makes the Blue PayPal button show 'Continue'
          vault: true,
          currency: this.officialCurrency,
          intent: 'capture'
        };
        if ((window as any)['process_env']['BRAINTREE_AUTOCOMPLETE_CHECKOUT'] == 'true' || document.location.search.indexOf('braintreeautocomplete=true') > -1) {
          paypalCheckoutInstancePayload['commit'] = true;
        }
        paypalCheckoutInstance.loadPayPalSDK(paypalCheckoutInstancePayload, () => {
          console.log('[GH] braintree paypal sdk loaded');
          if (!this.hidePaypalButton) {
            this.payPalLoader();
          }
          this.braintreeDisplayHandler();
        });
      });
    });
    // }
  }

  async actionHandler(data: any, actions: any) {
    console.log('[GH] braintree paypal shipping change', data);
    if (typeof data.paymentID == 'string') this.paypalpaymentId = data.paymentID;
    console.log('[GH] braintree paypal shipping change actions', actions);
    // initial offer price loaded here and updated on recalculations
    console.log('[GH] braintree paypal sdk loaded with funnel.offerPrice', this.upsell.offerPrice);
    console.log('[GH] braintree paypal sdk loaded with braintreeCurrencyConversion', this.braintreeCurrencyConversion);

    if (typeof data.shipping_address == 'object') {
      let validCountry = false;
      for (const key in this.countries) {
        //console.log('[GH] checking country ', key);
        if (this.countries.hasOwnProperty(key)) {
          //console.log('[GH] hasownproperty country ', key);
          if ((this.countries as any)[key].value == data.shipping_address.country_code) {
            //console.log('[GH] valid country ', (this.countries as any)[key].value);
            validCountry = true;
          }
        }
      }
      if (!validCountry) {
        console.log('[GH] invalid country ', data.shipping_address.country_code);
        return false;
      }
    }

    return true;
  }

  braintreeTokenizePayment() {
    this.spinner.enable('Please Wait...');
    return this.paypalCheckoutInstance.tokenizePayment(this.braintreeTokenizePaymentData, (err: any, payload: any) => {
      console.log('[GH] braintree paypal tokenized payment', payload);
      this.braintreePayPalEmail = payload.details.email;
      this.braintreeDropinValid = true;
      this.braintreePayPalTokenizedPayment = payload;
      try {
        if ((window as any)['process_env']['BRAINTREE_AUTOCOMPLETE_CHECKOUT'] !== 'true' && document.location.search.indexOf('braintreeautocomplete=true') == -1) {
          this.braintreeHidePayPalButton = true;
          if ((this.isSelectedCB2 && !this.isCheckoutCommonTC) || (!this.isSelectedCB2 && this.isCheckoutCommonTC)) this.changeStateCB2();
          //this.braintreeToast = this.toastCtrl.create({ message: 'Please review your order and click "Submit Order" below.', position: 'top', showCloseButton: true, cssClass: 'successToast' });
          this.spinner.disable();

        }
      } catch (e) {
        console.log('[GH] error in braintree paypal approve', e);
      }
    });
  }

  braintreeVaulting() {
    if (sessionStorage.getItem('braintreeUpsellVaulting') === 'true') {
      return true;
    }
    if (sessionStorage.getItem('braintreeDownsellVaulting') === 'true' && this.upsell.type === 'Downsell') {
      return true;
    }
    return false;
  }

  payPalLoader() {
    let styles = {
      shape: 'pill',
      label: '',
      height: 35
    };
    if (this.useNewBraintreeStyles) {
      styles = {
        shape: 'pill',
        label: 'checkout',
        height: 40
      };
    }

    (window as any)['paypal'].Buttons({
      style: styles,
      fundingSource: (window as any)['paypal'].FUNDING.PAYPAL,
      createOrder: () => {
        // initial offer price loaded here and updated on recalculations
        console.log('[GH] braintree paypal sdk loaded with totalPrice', +(this.upsell.offerPrice + this.upsell.shippingCost).toFixed(2));
        console.log('[GH] braintree paypal sdk loaded with braintreeCurrencyConversion', this.braintreeCurrencyConversion);
        let amount = ((+(this.upsell.offerPrice + this.upsell.shippingCost).toFixed(2)) * this.braintreeCurrencyConversion).toFixed(2);
        let subtotal = (1 * (this.upsell.offerPrice as any) * this.braintreeCurrencyConversion).toFixed(2);

        // https://www.paypal.com/ph/brc/article/psd2-payment-requirements-make-sure-you-are-ready
        let estimate = null;
        let estimateAmt = '0';

        let paypalOptions: any = {
          commit: true,
          requestBillingAgreement: this.braintreeVaulting(),
          flow: 'checkout',
          amount: amount,
          currency: this.officialCurrency,
          intent: 'capture', // Must match the intent passed in with loadPayPalSDK
          enableShippingAddress: false,
          shippingAddressEditable: false,
          shippingAddressOverride: {
            recipientName: this.orderDetailsInfo.order.customerName,
            line1: this.orderDetailsInfo.order.shippingAddress,
            line2: this.orderDetailsInfo.order.additionalShippingAddress,
            city: this.orderDetailsInfo.order.shippingCity,
            countryCode: this.calculateHelper.getCountryISOCode(this.countries, this.orderDetailsInfo.order.shippingCountry) || 'US',
            postalCode: this.orderDetailsInfo.order.shippingZipPostal,
            state: this.orderDetailsInfo.order.shippingState,
            email: this.orderDetailsInfo.customerEmail
          },
          billingAddressOverride: {
            recipientName: this.orderDetailsInfo.order.customerName,
            line1: this.orderDetailsInfo.order.billingAddress,
            line2: this.orderDetailsInfo.order.additionalBillingAddress,
            city: this.orderDetailsInfo.order.billingCity,
            countryCode: this.calculateHelper.getCountryISOCode(this.countries, this.orderDetailsInfo.order.billingCountry) || 'US',
            postalCode: this.orderDetailsInfo.order.billingZipPostal,
            state: this.orderDetailsInfo.order.billingState,
            email: this.orderDetailsInfo.customerEmail
          }
        };
        if (this.state && this.state.taxData) {
          let lineItems = [
            {
              name: "SubTotal",
              quantity: "1",
              kind: "debit",
              description: (this.state && this.state.taxData && this.state.taxData.productDetails) ? (this.state.taxData.productDetails as any)[0]['productDescription'] : document.title,
              unitAmount: subtotal,
              totalAmount: subtotal
            }
          ];
          paypalOptions['lineItems'] = lineItems;
          let checksum = parseFloat(amount) - (parseFloat(estimateAmt) + (parseFloat(subtotal) + parseFloat((this.dataForTax.totalTax * this.braintreeCurrencyConversion).toFixed(2).toString()) + parseFloat((this.upsell.shippingCost * this.braintreeCurrencyConversion).toFixed(2).toString())) + parseFloat((this.upsell.couponDiscount * this.braintreeCurrencyConversion).toFixed(2).toString()));
          if (!checksum) {
            checksum = 0;
          }
          if (parseFloat(checksum.toFixed(2)) != 0) {
            let kind = 'credit';
            if (checksum > 0) kind = 'debit';
            let correction = {
              name: "Currency Conversion Rounding Correction",
              quantity: "1",
              kind: kind,
              description: 'Currency Conversion Rounding Correction',
              unitAmount: checksum.toFixed(2).replace('-', ''),  // TODO deal with our number always being negative and braintree not liking that
              totalAmount: checksum.toFixed(2).replace('-', '')
            };
            paypalOptions['lineItems'].push(correction);
          }
        }
        if (estimate && paypalOptions['lineItems']) {
          paypalOptions['lineItems'].push(estimate);
        }
        console.log('[GH] braintree paypal options', paypalOptions);
        //this.emitCustomEvent('PayPalButtonClick', 'BrainTree');
        return this.paypalCheckoutInstance.createPayment(paypalOptions);
      },

      onShippingChange: async (data: any, actions: any) => {
/*         this.isSelectedCB2 = true;
 */        return this.actionHandler(data, actions).then((ret) => {
        console.log('[GH] braintree paypal shipping change response: ' + ret, data);
        if (!ret) return actions.reject();
        return actions.resolve();
      });
      },

      onApprove: (data: any, actions: any) => {
       // this.braintreeCustomLoadingMessage();
/*         this.isSelectedCB2 = true;
 */        console.log('[GH] braintree paypal approve', data);
        this.braintreeTokenizePaymentData = data;
        if (typeof data.paymentID == 'string') this.paypalpaymentId = data.paymentID;
        console.log('[GH] braintree paypal approve actions', actions);
        //this.braintreeTokenizePayment();
        this.braintreeGetNonce();
        // close the new overlay
        if (document.body.contains(this.overlayDiv)) {
          document.body.removeChild(this.overlayDiv);
        }
        //this.emitCustomEvent('PayPalApproved', 'Braintree');
      },

      onCancel: (data: any) => {
        console.log('[GH] handle cancel');
        (window as any)['facebookAutofillDisabled'] = false;
        console.log('PayPal payment cancelled', JSON.stringify(data));
        console.log('PayPal payment cancelled for guest', this.orderDetailsInfo.order.guest);
        if ((<HTMLDivElement>document.querySelector('#dropin-container'))) {
          (<HTMLDivElement>document.querySelector('#dropin-container')).style.display = 'block';
        }
        // this.emitCustomEvent('PayPalCancelled', 'BrainTree')  ;
        this.braintreePayPalTokenizedPayment = null;
        // close the new overlay
        if (document.body.contains(this.overlayDiv)) {
          document.body.removeChild(this.overlayDiv);
        }
        this.toastCtrl.create({
          message: `Please choose an option to continue`,
          position: 'top',
          duration: 3000
        });
      },

      onError: (err: any) => {
        console.log('todo handle error')
        console.error('PayPal error', err);
        this.spinner.disable();
        // this.emitCustomEvent('PayPalError', 'BrainTree');
        // close the new overlay
        if (document.body.contains(this.overlayDiv)) {
          document.body.removeChild(this.overlayDiv);
        }
        // show toast message
        this.toastCtrl.create({
          message: `Please choose an option to continue`,
          position: 'top',
          duration: 3000
        });
      }
    }).render('#paypal-button').then(() => {
      (<HTMLDivElement>document.querySelector('#paypal-button')).style.display = 'flex';
    });
  }

  createTransactionBraintree(upsell: any, response: any, captureId: any) {
    console.log('[GH] createTransactionBraintree upsell', upsell);
    console.log('[GH] createTransactionBraintree response', response);
    console.log('[GH] createTransactionBraintree orderId', upsell.id);
    console.log('[GH] createTransactionBraintree ' + this.braintreeCurrencyConversion);
    return new Promise((resolve, reject) => {
      let braintreeinterval = setInterval(async () => {
        clearInterval(braintreeinterval);
        this.tcrApiOrder.createTransaction({
          orderId: upsell.id, status: response.success ? 'Approved' : 'Failed',
          method: 'Braintree ' + response.transaction.currencyIsoCode ? response.transaction.currencyIsoCode : '', message: response.transaction.creditCard.maskedNumber.replace('null******null', 'PayPal') +
            ' token ' + response.transaction.creditCard.token + ' '
            + response.transaction.status + ' ' + response.transaction.currencyIsoCode ? response.transaction.currencyIsoCode : '' + ' currencyConversion ' + this.braintreeCurrencyConversion +
            ' ' + this.currencySymbol + (response.transaction.amount),
          original: JSON.stringify(response.transaction)
        })
          .subscribe((result: any) => {
            if (result.message === 'The transaction has been created') {
              resolve({ message: 'success' });
            } else {
              reject('Transaction was not created!');
            }
          }, (error: any) => {
            reject(error);
          });
      }, 300);
    });
  }

  async processBraintreeResult(result: any) { // TOUC-14710 - Braintree
    console.log('[GH] processBraintreeResult result', result);
    this.spinner.enable('Please wait...');

    if (typeof result.result.transaction.paypalAccount !== 'undefined') {
      let token = result.result.transaction.paypalAccount.implicitlyVaultedPaymentMethodToken;
      if (token) {
        sessionStorage.setItem('braintree-payment-token', token);
        console.log('[GH] braintree-payment-token', token);
      }
    }

    if (document.location.search.indexOf('braintreeforceupselldeclined=true') > -1) {
      console.log('[GH] braintreeforceupselldeclined=true');
      result.result.success = false;
    }

    if (result.result.success) {
      await this.createTransactionBraintree(result.upsell, result.result, 'Approved');
      setTimeout(async () => {
        await this.stateProvider.setPurchasedUpsells(result.upsell);

        if (this.paymentMethod.standard && this.transactionFeeAmount > 0) {
          this.captureTransactionFee(result.orderId);
          this.orderSTxId = '';
        }
        this.purchasedUpsells.push(result.upsell.order);
        const params: any = await this.funnelProvider.getNextPage(undefined, true);
        if (!params) {
          this.spinner.disable();
          return this.toastCtrl
            .create({
              message: `Page not found`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            })
        }
        const { component, orderForm, type } = params;
        if (type === 'Upsell' || type === 'Downsell') {
          await this.stateProvider.setUpsells([orderForm]);
        }
        this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true })
          .then(() => {
            this.spinner.disable();
          })
          .catch((error) => {
            this.toastCtrl.create({
              message: `Couldn't navigate to the next page`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            });
            console.log('Error on upgradeOrder()', error);
            this.spinner.disable();
          });
      }, 1000);

    } else {
      this.toastCtrl
        .create({
          message: `Error with upgrading order!  Please contact customer support.`,
          position: 'top',
        })
      //.present();
      this.createTransactionBraintree(result.upsell, result.result, 'Failed');
      const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
      if (!params) {
        this.spinner.disable();
        return this.toastCtrl
          .create({
            message: `Page not found`,
            position: 'top',
            showCloseButton: true,
            cssClass: 'errorToast',
          })
        //.present();
      }
      const { component } = params;
      this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true })
        .then(() => {
          this.spinner.disable();
        })
        .catch((error) => {
          this.toastCtrl.create({
            message: `Couldn't navigate to the next page`,
            position: 'top',
            showCloseButton: true,
            cssClass: 'errorToast',
          });
          console.log('Error on upgradeOrder()', error);
          this.spinner.disable();
        });
    }
  }

  upgradeOrder() {
    this.spinner.enable('Updating order.<br>Please Wait');
    let upsells = [{ sfid: this.upsell.sfid, count: 1 }];
    let dataForTax = this.tcrApiRemoteServices.getDataForTaxUpgradeOrder(
      this.dataForTax,
      this.upsell,
    );
    let totalTax = this.taxRate.totalTax || 0;

    if (this.paymentMethod.paypal) {
      this.toastCtrl.create({ message: `Updating order...`, duration: 3000, position: 'top' })//.present();
      this.upgradePayPalOrder();
    } else if (this.paymentMethod.braintreeMethod && sessionStorage.getItem('braintree-payment-token') && sessionStorage.getItem('braintree-payment-token') != 'null') {
      this.toastCtrl.create({ message: `Updating order...`, duration: 3000, position: 'top' })//.present();
      this.upgradeBraintreeOrder(sessionStorage.getItem('deviceData'));  // TOUC-14710  -  Braintree GBP
    } else if (this.paymentMethod.braintreeMethod) {
      const braintreeToken = sessionStorage.getItem('braintree-payment-token');
      if (!braintreeToken || braintreeToken === 'null') {
        this.spinner.disable();
        // Show PayPal button dialog instead of alert
        this.showPayPalButtonDialog();

        // Add PayPal button styles
        const styles = {
          layout: 'vertical',
          color: 'gold',
          shape: 'rect',
          label: 'paypal'
        };

        this.setupBraintreeClient().then(() => {
          console.log('[GH] braintree client setup complete');


        }).catch((e) => {
          console.log('[GH] braintree client setup exception ', e);
          this.tearDownBraintree();
        });
        const rate = this.braintreeCurrencyConversion = parseFloat(this.orderDetailsInfo.order.crv);
        console.log('[GH] braintree currency conversion rate', rate);
      }
    } else {
      // Previously we vaulted all transactions per Braintree's recommendation, but now we only vault subscription payments
      this.toastCtrl.create({ message: `Updating order...`, duration: 3000, position: 'top' })//.present();
      this.order.transactionFeeAmount = this.transactionFeeAmount;
      this.order.transactionFeeDocumentId = this.orderSTxId;
      this.tcrApiOrder
        .payUpsells(this.order, upsells, this.upsell.type, totalTax, dataForTax)
        .toPromise()
        .then(
          async (result: any) => {
            const stp = this.urlsHelper.getParameterFromUrl({ url: document.location.search, parameter: 'step' })
            this.spinner.enable('Please wait...');
            if (result.message === 'success') {
              if (this.paymentMethod.standard && this.transactionFeeAmount > 0) {
                this.captureTransactionFee(result.orderId);
                this.orderSTxId = '';
              }
              this.purchasedUpsells.push(result.order);
              await this.stateProvider.setPurchasedUpsells(result.order);

              // Handle multi-upsell navigation
              if (this.isMultiUpsell) {
                const currentFunnelStep = Number(stp) || Number(this.currentStep);
                const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, true);
                return this.redirectToStep(nextStep,false);
              }

              const params: any = await this.funnelProvider.getNextPage(undefined, true);
              if (!params) {
                this.spinner.disable();

                if (typeof (window as any)['funnelConfsForUUID'] == 'object') {
                  // handle the configuration error
                  let brokenfunnel = (window as any)['funnelConfsForUUID'];
                  let brokenfunnel_firstUpsell = brokenfunnel.defaultFunnels[stp].variants[0].url;
                  let alt = this.getAlternativeOffer(brokenfunnel_firstUpsell);
                  if (alt) {
                    console.log("redirecting to alternative offer: " + alt);
                    //return this.navCtrl.setRootExt(alt, { name: alt},{currentStep: stp, nextStep: (stp+1) });
                    //return this.navCtrl.setRootExt(alt, { name: alt});
                    return this.navCtrl.setRootExt(alt, { name: alt, isUpsell: true }, { taken: true, alternate: true })

                  }
                }

                return this.toastCtrl
                  .create({
                    message: `Page not found`,
                    position: 'top',
                    showCloseButton: true,
                    cssClass: 'errorToast',
                  })
                // .present();
              }
              const { component, orderForm, type, defaultFunnel } = params;
              if (type === 'Upsell' || type === 'Downsell') {
                await this.stateProvider.setUpsells([orderForm]);
              }
              // Pass the correct step from the found funnel to support both old and new patterns
              const nextStep = defaultFunnel && defaultFunnel.step ? defaultFunnel.step : undefined;
              this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true, nextStep: nextStep })
                .then(() => {
                  this.spinner.disable();
                })
                .catch((error) => {
                  this.toastCtrl.create({
                    message: `Couldn't navigate to the next page`,
                    position: 'top',
                    showCloseButton: true,
                    cssClass: 'errorToast',
                  });
                  console.log('Error on upgradeOrder()', error);
                  this.spinner.disable();
                });
            } else {
              // Handle multi-upsell navigation for failed purchases
              if (this.isMultiUpsell) {
                const currentFunnelStep = Number(stp) || Number(this.currentStep);
                const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, false);
                return this.redirectToStep(nextStep,true);
              }

              const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
              if (!params) {
                this.spinner.disable();
                return this.toastCtrl
                  .create({
                    message: `Page not found`,
                    position: 'top',
                    showCloseButton: true,
                    cssClass: 'errorToast',
                  })
                // .present();
              }
              const { component, defaultFunnel } = params;
              // Pass the correct step from the found funnel to support both old and new patterns
              const nextStep = defaultFunnel && defaultFunnel.step ? defaultFunnel.step : undefined;
              this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true, nextStep: nextStep })
                .then(() => {
                  this.spinner.disable();
                })
                .catch((error) => {
                  this.toastCtrl.create({
                    message: `Couldn't navigate to the next page`,
                    position: 'top',
                    showCloseButton: true,
                    cssClass: 'errorToast',
                  });
                  console.log('Error on upgradeOrder()', error);
                  this.spinner.disable();
                });
            }
            return;
          },
          async (error: any) => {
            console.log('Error on upsell purchase!', error);
            this.spinner.disable();

            // Handle multi-upsell navigation for errors
            if (this.isMultiUpsell) {
              const currentFunnelStep = Number(this.currentStep);
              const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, false);
              return this.redirectToStep(nextStep,true);
            }

            const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
            if (!params) {
              this.spinner.disable();
              return this.toastCtrl
                .create({
                  message: `Page not found`,
                  position: 'top',
                  showCloseButton: true,
                  cssClass: 'errorToast',
                })
              // .present();
            }
            const { component, defaultFunnel } = params;
            // Pass the correct step from the found funnel to support both old and new patterns
            const nextStep = defaultFunnel && defaultFunnel.step ? defaultFunnel.step : undefined;
            return this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true, nextStep: nextStep })
              .then(() => {
                this.spinner.disable();
              })
              .catch((error) => {
                this.toastCtrl.create({
                  message: `Couldn't navigate to the next page`,
                  position: 'top',
                  showCloseButton: true,
                  cssClass: 'errorToast',
                });
                console.log('Error on upgradeOrder()', error);
                this.spinner.disable();
              });
          },
        );
    }
  }

  upgradePayPalOrder() {
    this.spinner.enable('Executing order.<br> Please Wait');
    let dataForTax = this.tcrApiRemoteServices.getDataForTaxUpgradeOrder(
      this.dataForTax,
      this.upsell,
    );
    let paymentData = {
      totalPrice: +(this.upsell.offerPrice + this.upsell.shippingCost).toFixed(2),
      accDetails: this.orderDetailsInfo.navParams.accDetails,
      orderType: this.upsell.type,
      OffersData: [],
      bumpOffers: [],
      parentOrder: this.orderDetailsInfo.navParams.order,
      totalTax: this.taxRate.totalTax || 0,
      dataForTax: dataForTax,
      countries: this.countries
    };
    (paymentData.OffersData as any).push(this.upsell);
    this.paypalPayment.createPaymentUpsell(paymentData).then(
      (result: any) => {
        this.purchasedUpsells.push(result.order);
        this.stateProvider
          .setOrderDetails({
            order: this.orderDetailsInfo.navParams.order,
            upsells: this.orderDetailsInfo.navParams.upsells,
            purchasedUpsells: this.purchasedUpsells,
            upsellIndex: this.upsellIndex,
            paymentMethod: 'PayPal',
          })
          .then((state) => {
            this.state = state;
            this.plannedLeavePage = true;
            console.log('[GH] saving PayPalNVPParameters', document.location.search)
            sessionStorage.setItem('PayPalNVPParameters', document.location.search);
            window.open(result.url, '_self', 'location=no');
          });
      },
      () => {
        this.toastCtrl
          .create({
            message: `Error with upgrading paypal order!`,
            duration: 3000,
            position: 'top',
          })
        //.present();
        this.spinner.disable();
      },
    );
  }

  upgradeBraintreeOrder(deviceData: any) {
    this.spinner.enable('Executing order.<br> Please Wait');
    let dataForTax = this.tcrApiRemoteServices.getDataForTaxUpgradeOrder(
      this.dataForTax,
      this.upsell,
    );
    let paymentData = {
      totalPrice: +(this.upsell.offerPrice + this.upsell.shippingCost).toFixed(2),
      accDetails: this.orderDetailsInfo.navParams.accDetails,
      orderType: this.upsell.type,
      OffersData: [],
      bumpOffers: [],
      parentOrder: this.orderDetailsInfo.navParams.order,
      totalTax: this.taxRate.totalTax || 0,
      dataForTax: dataForTax,
      countries: this.countries,
      paymentMethod: this.orderDetailsInfo.navParams.paymentMethod,
      namedAgent: 'Braintree'
    };
    (paymentData.OffersData as any).push(this.upsell);
    // TODO - this creates the order by not a payment profile yet for guest user MVP version
    this.paypalPayment.createOrderBraintreeUpsell(paymentData).then(
      (result: any) => {
        console.log('before order', this.order);
        console.log('before this.upsell', this.upsell);
        console.log('before result', result);
        this.purchasedUpsells.push(result.order);
        this.stateProvider
          .setOrderDetails({
            order: this.orderDetailsInfo.navParams.order,
            upsells: this.orderDetailsInfo.navParams.upsells,
            purchasedUpsells: this.purchasedUpsells,
            upsellIndex: this.upsellIndex,
            paymentMethod: this.orderDetailsInfo.navParams.paymentMethod
          })
          .then((state) => {
            this.state = state;
            let braintreeClientToken = sessionStorage.getItem('braintree-payment-token');
            console.log('after order', this.order);
            console.log('after this.upsell', this.upsell);
            console.log('after result', result);
            const countryISO = this.calculateHelper.getCountryISOCode(this.countries, this.order.billCountry);
            let braintreeCurrencyConversion = this.order.crv || '1';
            let description = result.order.name + ' currencyConversion ' + this.braintreeCurrencyConversion + ' Total: $' + (result.order.total) + '  Tax: $' + result.order.tax;
            console.log('orderDetailsInfo', this.orderDetailsInfo);
            let body: any = {
              "orderTotal": +(result.order.total * parseFloat(braintreeCurrencyConversion)).toFixed(2),
              "totalPrice": +(result.order.total * parseFloat(braintreeCurrencyConversion)).toFixed(2),
              "totalTax": +(result.order.tax * parseFloat(braintreeCurrencyConversion)).toFixed(2),
              "braintreeCurrencyConversion": braintreeCurrencyConversion,
              "submitForSettlement": true,
              "accDetails": {
                "email": this.order.customerEmail,
                "billingAddress": {
                  "country": result.order.billingCountry,
                  "state": result.order.billingState,
                  "city": result.order.billingCity,
                  "street": result.order.billingAddress,
                  "postal": result.order.billingZip,
                  "st": result.order.billingState
                },
              },
              "billingCountryAlpha2": countryISO,
              "amount": +(result.order.total * parseFloat(braintreeCurrencyConversion)).toFixed(2).toString(),
              "currency": sessionStorage.getItem('officialCurrency'),
              "deviceData": deviceData,
              "description": description
            }
            if (braintreeClientToken && braintreeClientToken != "null" && braintreeClientToken != "undefined") {
              // durable token found
              body['paymentMethodToken'] = braintreeClientToken;
            } else {
              // no token, need a new nonce
              body['nonce'] = this.braintreeNonce;
              body['authorize'] = false;
              body['currency'] = sessionStorage.getItem('officialCurrency') || 'USD';
              body['orderId'] = result.order.id;
              body['amount'] = result.order.total;
              body['deviceData'] = deviceData;
              body['subTotalAmount'] = result.order.total.toString();
              body['taxAmount'] = result.order.tax.toString();
              body['shippingAmount'] = "0.00"; //TODO - add shipping amount
              body['discountAmount'] = "0.00"; //TODO - add discount amount
              body['options'] = {
                "submitForSettlement": true,
                "storeInVaultOnSuccess": true
              };
              body['custom_fields'] = {
                "merchant_order_details": description
              };
              body['customer'] = {
                "email": result.order.customerEmail,
                "firstName": result.order.billFirstName,
                "lastName": result.order.billLastName,
              };
              body['billing'] = {
                "firstName": result.order.billFirstName,
                "lastName": result.order.billLastName,
                "streetAddress": result.order.billingAddress,
                "extendedAddress": result.order.billingAddress2,
                "locality": result.order.billingCity,
                "region": result.order.billingState,
                "postalCode": result.order.billingZip,
                "countryName": result.order.billingCountry
              };
              body['shipping'] = {
                "firstName": result.order.shipFirstName,
                "lastName": result.order.shipLastName,
                "streetAddress": result.order.shipAddress,
                "extendedAddress": result.order.shipAddress2,
                "locality": result.order.shipCity,
                "region": result.order.shipState,
                "postalCode": result.order.shipZip,
                "countryName": result.order.shipCountry
              };
              body['braintreeMethod'] = 'paypal_checkout_vault';
              body['paymentMethodNonce'] = this.braintreeNonce;
              body['authorize'] = false;
            }
            let xhr = new XMLHttpRequest();
            let asy = false;
            xhr.open('POST', '/checkout-braintree/', asy);
            xhr.withCredentials = true;
            if (typeof (window as any)['getCookie'] === 'function') xhr.setRequestHeader('XSRF-TOKEN', (window as any)['getCookie']('XSRF-TOKEN')); // [TOUC-5682]
            xhr.onload = (e) => {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  console.log('[GH] braintree response', JSON.parse(xhr.responseText));
                  let ret = JSON.parse(xhr.responseText);
                  ret['order'] = this.order;
                  ret['upsell'] = result.order;
                  this.processBraintreeResult(ret);
                  return xhr.responseText;
                } else {
                  console.error('[GH] Braintree error ', xhr.statusText);
                  this.spinner.disable();
                  this.toastCtrl
                    .create({
                      message: `Error with upgrading braintree order.`,
                      position: 'top',
                      showCloseButton: true,
                      cssClass: 'errorToast',
                    })
                  //.present();
                  this.navCtrl.setRootExt('OrderSuccessCommonPage', {
                    name: 'Order Success', isUpsell: true
                  });
                  return { error: true, message: xhr.statusText };
                }
              }
              return;
            };
            xhr.onerror = (e) => {
              console.error(xhr.statusText);
            };

            (xhr as any)['dataType'] = 'json';
            xhr.setRequestHeader('X-Brand', (window as any)['process_env'].BRAND);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            console.log('[GH] braintree request body', body);
            xhr.send(JSON.stringify(body));


          });
      },
      () => {
        this.toastCtrl
          .create({
            message: `Error with upgrading braintree paypal order!`,
            duration: 3000,
            position: 'top',
          })
        // .present();
        this.spinner.disable();
      },
    );
  }

  executePayPalPayment(paramData: any) {
    this.spinner.enable('Executing order.<br> Please Wait');
    paramData['isUpsell'] = true;
    paramData.dataForTax = this.state.taxData;
    this.paypalPayment.executePayment(paramData)
      .then(async (res: any) => {
        this.spinner.enable('Loading page <br> Please wait...');
        if (res.message === 'success') {
          // Save the purchased upsell
          await this.stateProvider.setPurchasedUpsells(res.orderDetails.purchasedUpsells[res.orderDetails.purchasedUpsells.length - 1]);
          // Handle multi-upsell navigation
          if (this.isMultiUpsell) {
            const currentFunnelStep = Number(this.urlsHelper.getParameterFromUrl({ url: document.location.search, parameter: 'step' })) || Number(this.currentStep);
            const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, true);
            return this.redirectToStep(nextStep,false);
          }

          const params: any = await this.funnelProvider.getNextPage(undefined, true);
          if (!params) {
            this.spinner.disable();
            return this.toastCtrl
              .create({
                message: `Page not found`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              })
          }
          const { component, orderForm, type } = params;
          if (type === 'Upsell' || type === 'Downsell') {
            await this.stateProvider.setUpsells([orderForm]);
          }
          this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true })
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on executePayPalPayment()', error);
              this.spinner.disable();
            });
          return;
        } else {
          // Handle multi-upsell navigation for failed purchases
          if (this.isMultiUpsell) {
            const currentFunnelStep = Number(this.urlsHelper.getParameterFromUrl({ url: document.location.search, parameter: 'step' })) || Number(this.currentStep);
            const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, false);
            return this.redirectToStep(nextStep,true);
          }

          const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
          if (!params) {
            this.spinner.disable();
            return this.toastCtrl
              .create({
                message: `Page not found`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              })
          }
          const { component } = params;
          this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true })
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on executePayPalPayment()', error);
              this.spinner.disable();
            });
        }
      },
        async (error) => {
          console.log('Error on upsell purchase!', error);
          this.spinner.enable('Loading page <br> Please wait...');

          // Handle multi-upsell navigation for errors
          if (this.isMultiUpsell) {
            const currentFunnelStep = Number(this.currentStep);
            const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, false);
            return this.redirectToStep(nextStep,true);
          }

          const params = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
          if (!params) {
            this.spinner.disable();
            return this.toastCtrl
              .create({
                message: `Page not found`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              })
          }
          const { component } = params;
          this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true })
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on executePayPalPayment()', error);
              this.spinner.disable();
            });
        },
      );
  }

  executePayPalNVP(urlParameters: any, upsellOrder: any) {
    this.urlsHelper.clearPayPalParams();
    this.spinner.enable('Executing order.<br> Please Wait');
    const upsellOrderDetails = {
      order: upsellOrder,
      isUpsell: true
    };
    const shippingFullCountry = upsellOrderDetails.order.shippingCountry;
    const countryISO = this.calculateHelper.getCountryISOCode(this.countries, shippingFullCountry);
    const stateISO = this.countries && this.countries[shippingFullCountry] && this.countries[shippingFullCountry].states ?
      Object.keys(this.countries[shippingFullCountry].states).find(e => this.countries[shippingFullCountry].states[e] === upsellOrderDetails.order.shippingState)
      : upsellOrderDetails.order.shippingState;
    let executeBody = {
      order: upsellOrderDetails,
      paymentBody: {
        TOKEN: urlParameters.token,
        PAYERID: urlParameters.PayerID,
        PAYMENTREQUEST_0_AMT: +upsellOrderDetails.order.total.toFixed(2),
        PAYMENTREQUEST_0_CURRENCYCODE: 'USD',
        PAYMENTREQUEST_0_SHIPTONAME: upsellOrderDetails.order.customerName,
        PAYMENTREQUEST_0_SHIPTOSTREET: upsellOrderDetails.order.shippingAddress,
        PAYMENTREQUEST_0_SHIPTOCITY: upsellOrderDetails.order.shippingCity,
        PAYMENTREQUEST_0_SHIPTOSTATE: stateISO,
        PAYMENTREQUEST_0_SHIPTOZIP: upsellOrderDetails.order.shippingZipPostal,
        PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE: countryISO,
        L_PAYMENTREQUEST_0_AMT0: +upsellOrderDetails.order.orderItems[0].totalPrice,
        L_PAYMENTREQUEST_0_NAME0: upsellOrderDetails.order.orderItems[0].productName,
        L_PAYMENTREQUEST_0_QTY0: upsellOrderDetails.order.orderItems[0].quantity,
        PAYMENTREQUEST_0_ITEMAMT: +upsellOrderDetails.order.orderItems[0].productPrice.toFixed(2),
        PAYMENTREQUEST_0_SHIPPINGAMT: +upsellOrderDetails.order.orderShippingCost.toFixed(2),
        PAYMENTREQUEST_0_TAXAMT: +upsellOrderDetails.order.tax.toFixed(2),
      }
    };
    if (this.taxServiceEnabled) {
      (executeBody as any)['dataForTax'] = this.state.taxData;
    }

    this.tcrApiOrder.doExpressCheckout(executeBody)
      .subscribe(async (response: any) => {
        this.spinner.enable('Loading page <br> Please wait...');
        await this.stateProvider.setPurchasedUpsells(response.order);
      // Handle multi-upsell navigation
        if (this.isMultiUpsell) {
          const currentFunnelStep = Number(this.urlsHelper.getParameterFromUrl({ url: document.location.search, parameter: 'step' })) || Number(this.currentStep);
          const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, true);
          return this.redirectToStep(nextStep, false);
        }

        const params: any = await this.funnelProvider.getNextPage(undefined, true);
        if (!params) {
          this.spinner.disable();
          return this.toastCtrl
            .create({
              message: `Page not found`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            })
          // .present();
        }
        const { component, orderForm, type, defaultFunnel } = params;
        if (type === 'Upsell' || type === 'Downsell') {
          await this.stateProvider.setUpsells([orderForm]);
        }
        // Pass the correct step from the found funnel to support both old and new patterns
        const nextStep = defaultFunnel && defaultFunnel.step ? defaultFunnel.step : undefined;
        this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true, nextStep: nextStep })
          .then(() => {
            this.spinner.disable();
          })
          .catch((error) => {
            this.toastCtrl.create({
              message: `Couldn't navigate to the next page`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            });
            console.log('Error on executePayPalNVP()', error);
            this.spinner.disable();
          });
      }, async (error) => {
        this.spinner.enable('Loading page <br> Please wait...');

        // Handle multi-upsell navigation for errors
        if (this.isMultiUpsell) {
          const currentFunnelStep = Number(this.urlsHelper.getParameterFromUrl({ url: document.location.search, parameter: 'step' })) || Number(this.currentStep);
          const nextStep = await this.funnelNavService.getNextStepForMultiUpsell(currentFunnelStep, false);
          return this.redirectToStep(nextStep, true);
        }

        this.spinner.disable();
        const params = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
        if (!params) {
          this.spinner.disable();
          return this.toastCtrl
            .create({
              message: `Page not found`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            })
          // .present();
        }
        const { component } = params;
        this.navCtrl.setRootExt(component.path, { name: component.path, isUpsell: true }, { taken: true })
          .then(() => {
            this.spinner.disable();
          })
          .catch((error) => {
            this.toastCtrl.create({
              message: `Couldn't navigate to the next page`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            });
            console.log('Error on executePayPalNVP()', error);
            this.spinner.disable();
          });
      });
  }

  getTaxRateForUpsells(data: any) {
    // generate data for get tax amount for upsels
    let dataForTax: any = {};
    let shipCountry = data.detailsInfo.order.shippingCountry;
    let shipState = data.detailsInfo.order.shippingState;

    if (data.upsellIndex < 0) {
      data.upsellIndex = 0;
    }

    if (this.countries && this.countries[shipCountry] && this.countries[shipCountry].states) {
      for (let state in this.countries[shipCountry].states) {
        this.statesList.push({ value: state, label: this.countries[shipCountry].states[state] });
      }
    }

    let to_state = '';
    for (let i = 0; i < this.statesList.length; i++) {
      if (this.statesList[i].label === shipState) {
        to_state = this.statesList[i].value;
      }
    }

    let accountDetails = {
      shipTo: {
        line1: data.detailsInfo.order.shippingAddress,
        city: data.detailsInfo.order.shippingCity,
        region: to_state || shipState,
        country: this.countries[shipCountry] ? this.countries[shipCountry].value : shipCountry,
        postalCode: data.detailsInfo.order.shippingZipPostal,
      },
    };

    dataForTax['accountDetails'] = accountDetails;
    let productDetails = [];
    let item = {};
    item = {
      number: data.detailsInfo.upsells[data.upsellIndex].sfid,
      quantity: 1,
      amount: data.detailsInfo.upsells[data.upsellIndex].offerPrice,
      taxCode: data.detailsInfo.upsells[data.upsellIndex].productTaxCode,
      description: data.detailsInfo.upsells[data.upsellIndex].name,
      productDescription: data.detailsInfo.upsells[data.upsellIndex].productDescription,
    };
    productDetails.push(item);
    dataForTax.productDetails = productDetails;
    dataForTax.shipping = data.detailsInfo.upsells[data.upsellIndex].shippingCost;
    dataForTax.total = data.detailsInfo.upsells[data.upsellIndex].offerPrice;
    return dataForTax;
  }

  private buildInterpolationVariables(data: any): Record<string, any> {
    const variables: Record<string, any> = {};

    // Include all properties from data object (allows any variable)
    Object.assign(variables, data);

    // Also include all properties from this class instance
    Object.assign(variables, this);

    return variables;
  }

  private interpolateString(template: string, variables: Record<string, any>): string {
    try {
      const regex = /\$\{\s*(.*?)\s*\}/g;

      // Replace missing variables with values from the class instance (this) or fallback message
      const processedTemplate = template.replace(regex, (_, key) => {
        // Handle conditional logic for free shipping text
        if (key == 'freeShippingText') {
          // Use custom text from JSON if provided, otherwise use default
          const customShippingText = variables.freeShippingText || ' + Free Shipping & Handling';
          return !this.currency || this.currency === 'USD' ? customShippingText : '';
        }

        // Handle fallback for productNameAlternate to productName
        if (key == 'productNameAlternate') {
          const alternateName = variables.productNameAlternate || (this as any).productNameAlternate;
          const fallbackName = variables.productName || (this as any).productName;
          return alternateName || fallbackName || `[🔴${key} not found]`;
        }

        if (key in variables) {
          return variables[key]; // Use value from variables passed in JSON
        } else if (key in this) {
          return (this as any)[key]; // Use value from class properties if available
        } else {
          console.warn(`Variable ${key} not found.`);
          return `[🔴${key} not found]`; // Use fallback for missing variables
        }
      });

      return processedTemplate;
    } catch (error) {
      console.error('Interpolation failed:', error, template);
      return template; // Return original template on failure
    }
  }

  private interpolateAllStrings(obj: any, variables: Record<string, any>): any {
    if (typeof obj === 'string') {
      return this.interpolateString(obj, variables);
    } else if (Array.isArray(obj)) {
      return obj.map(item => this.interpolateAllStrings(item, variables));
    } else if (typeof obj === 'object' && obj !== null) {
      const newObj: any = {};
      for (const [key, value] of Object.entries(obj)) {
        newObj[key] = this.interpolateAllStrings(value, variables);
      }
      return newObj;
    }
    return obj;
  }

  loadStyle(href: string): void {
    const existingLink = this.document.querySelectorAll('link.dynamicCss');
    if (existingLink.length > 0) {
      existingLink.forEach(link => {
        this.renderer.setAttribute(link, 'href', href);
      })
    } else {
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'stylesheet');
      this.renderer.setAttribute(link, 'type', 'text/css');
      this.renderer.setAttribute(link, 'class', 'dynamicCss');
      this.renderer.setAttribute(link, 'href', href);
      this.renderer.appendChild(this.document.head, link);
    }
  }

  applyRouteData() {
    if (this.route) {
      this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
        this.convertedPrices();

        this.isMultiUpsell = data.isMultiUpsell ?? false;

        this.productQuantity = data.productQuantity ?? this.productQuantity;
        this.productUnitType = data.unitType ?? this.productUnitType;
        this.productUnitTypeNextUp = data.unitTypes ?? this.productUnitTypeNextUp;
        this.productQuantityPack = data.productQuantityPack ?? this.productQuantityPack;

        if (data.isDownsell) {
          this.productQuantityNextUp = data.productQuantityNextUp ?? this.productQuantityNextUp;

          if (data.quantity > 1) {
            this.productUnitType = data.unitTypes ?? this.productUnitType;
          }
        }

        const variables = this.buildInterpolationVariables(data);
        const interpolatedData = this.interpolateAllStrings(data, variables);

        Object.assign(this, interpolatedData);

        if (this.customCssPath) {
          this.loadStyle(this.customCssPath);
        }
      });
    }
  }

  convertedPrices(): string {
    this.regularPriceConverted = this.dynamicCurrencyPipe.transform(this.productRegularPrice, this.currency);
    this.instantSavingsConverted = this.dynamicCurrencyPipe.transform(this.productInstantSavings, this.currency );
    this.yourPriceConverted = this.dynamicCurrencyPipe.transform(this.productYourPrice, this.currency);

    return this.yourPriceConverted || ''; // Ensure a string is returned
  }

  nextPage(event: any) {
    //this.navCtrl.animate=true;
    console.log("NEXT PAGE TEST ", event);
    if (event) {
      if (this.beforeunloadHandler && window.removeEventListener) {
        window.removeEventListener("beforeunload", this.beforeunloadHandler);
      }
      this.beforeunloadHandler = (e:any) => { };
      this.analyticsService.sendCustomEvent('Upgrade Clicked', { initTimer: this.initTimer, scrollEvents: this.scrollEvents });
      // decide later which toast to show
      //this.toastCtrl.create({ message: `Updating order...`, duration: 3000, position: 'top' })//.present();
      this.upgradeOrder();
    } else {
      this.analyticsService.sendCustomEvent('No Thanks Clicked', { initTimer: this.initTimer, scrollEvents: this.scrollEvents });
      this.handleNoThanks();
    }
    setTimeout(() => {
      this.navCtrl.animate = false;
    }, 1000);

    // this was when TCR owned the upsell base code
    // this.checkParams(); //TOUC-1202
  }

  public getUpsellPathName() {
    if (location.pathname.indexOf('{') > -1) return '';
    return location.pathname.substring(1);
  }
  public getHere() {
    return window.location.href ; // [TOUC-5682]
  }
  //Use to set custom title of the page

  public async ngAfterContentInit(): Promise<void> {
    const component = this.funnelProvider.getComponent(`${this.getUpsellPathName()}`);
    if (component) {
      this.eventStreamer.streamEvent("appScreenView", {
        screenPath: `${this.getUpsellPathName()}`,
        screenName: (document.querySelector('router-outlet') as any).nextElementSibling.tagName.toLowerCase().replace(/-([a-z])/g, function (m:any, w:any) {
          return w.toUpperCase();
        }),
        customTitle: component.path,
        fullUrl: `${this.getHere()}`,
      });
    }
    let titleId = document.getElementById('title');
    if (titleId) {
      titleId.innerHTML = this.upsell && this.upsell.product ? this.upsell.product.name : BRAND + ' - Preview Offer';
    }

    try {
      if (document.location.search.indexOf('unit_') > -1) {
        this.originalPurchaseQuantity = parseInt(document.location.search.substring(document.location.search.indexOf('unit_') - 2, document.location.search.indexOf('unit_')).replace('_', ''));
      }
    } catch (e) {
      console.log('trouble retrieving the original purchase quantity');
    }
    await this.funnelProvider.getAndApplyContentPage(this);
  }

  // Clear storage and create shipping invoice if leave page
  ngOnDestroy() {
    this.spinner.disable();
    setTimeout(() => {
      this.elementRef.nativeElement.remove();
    }, 1);

    this.mintercnt = 9999;
    if (this.beforeunloadHandler) {
      window.removeEventListener("beforeunload", this.beforeunloadHandler);
    }
    if (this.saveduserHandler) {
      window.removeEventListener("focus", this.saveduserHandler);
    }
    if (this.visibilityStateChangeHandler) {
      window.removeEventListener("visibilitychange", this.visibilityStateChangeHandler);
    }
  }

  private async initUpsellPage() {
    window.scrollTo({ top: 0, behavior: 'instant' });
    // Fix for Android scroll issue - ensure page starts at top (run immediately)
    if (document.documentElement.scrollTop > 0) {
      document.documentElement.scrollTop = 0;
    }

    this.updateWithRoutesData();

    (window as any)['stepGateClosed'] = false;

    let body = document.getElementsByTagName('body')[0];
    body.setAttribute('data-qa','upsell-page');

    //async ionViewDidLoad() {
    //this.spinner.enable('Loading page.<br>Please Wait');
    try {
      this.initTimer = new Date().getTime(); // TOUC-902
      setTimeout(() => { this.analyticsService.sendCustomEvent('Sell Page View', { initTimer: this.initTimer, scrollEvents: this.scrollEvents }); }, 1000); // TOUC-982
      (document.querySelector('body') as any).addEventListener('scroll', (e:any) => {
        this.scrollEvents++;
      });
    } catch (e) {
      console.log("TOUC-982 warning setting up scroll handler ", e);
    }

    this.priceWithTax = this.dynamicCurrencyPipe.checkPriceWithTax(this.currency);
    this.isAmazonScriptLoaded = false;
    this.state = await this.stateProvider.get();
    this.orderProducts = []

    try { // TOUC-962
      if (!this.state || !this.state.orderDetails || (document.location.search && document.location.search.indexOf("pseudoState=true") > -1)) {
        if (localStorage.getItem("debugMode") == 'true') {
          this.state = this.debugService.getPseudoState() as State;
        }
      }
    } catch (e) {
      console.log("TOUC-962 error", e);
    }

    if (!this.state) {
      console.info('[GH] redirecting to Home because this.state is not found', this.state);
      return this.navCtrl.setRootExt('Home', { name: 'Home' });
    }

    if (this.state.upsells) {
      this.orderProducts = [this.state?.orderDetails?.order, ...this.state?.upsells,]

    } else {
      this.orderProducts = [this.state?.orderDetails?.order]

      //console.log('2abc', this.orderProducts)
    }
    this.totalTax = Math.round((this.orderProducts.reduce((a, b) => {
      return a + b?.tax
    }, 0) + Number.EPSILON) * 100) / 100;

    // [TOUD-5477]

    if (!this.state || !this.state.orderDetails) {
      const params: any = await this.funnelProvider.getPageByStep('first');
      if (!params) {
        return this.navCtrl.setRootExt('Home', { name: 'Home' });
      }
      const { component } = params;
      return this.navCtrl.pushExt(component.name, { name: component.name }).then(() => {
        return this.navCtrl.clearStack();
      });
    } else {
      try {
        const order = this.state.orderDetails.order;
        if (order) {
          (window as any)['USER_EMAIL'] = order.customerEmail;
          (window as any)['CONVERSION_ID'] = order.name;
          (window as any)['ORDER_TOTAL'] = order.total;
          console.log("conversion happened: " + (window as any)['USER_EMAIL'] + '::' + (window as any)['CONVERSION_ID'])
          console.log('attempting to set ctotal or cid cookies: ' + (window as any)['ORDER_TOTAL'] + ' ' + (window as any)['CONVERSION_ID']);
          document.cookie = 'ctotal=' + (window as any)['ORDER_TOTAL'] + '; expires=3600; path=/';
          document.cookie = 'cid=' + (window as any)['CONVERSION_ID'] + '; expires=3600; path=/';
        }
      } catch (e) {
        console.log('unable to set ctotal or cid cookies: ' + e);
      }

      if (!this.isStorageAvailable && this.state.orderDetails.paymentMethod == 'PayPal' && this.state.orderDetails.order) {
        return this.stateProvider.setPageNameAndOrder(this.stateProvider.ORDER_SUCCESS, this.state.orderDetails.order)
          .then(() => {
            console.log('redirect to order success');
            this.plannedLeavePage = true;
            this.analyticsService.sendCustomEvent(`THANK YOU`, { initTimer: this.initTimer, scrollEvents: this.scrollEvents }, 'paypal no storage');

            return this.navCtrl.setRootExt(this.stateProvider.ORDER_SUCCESS, { name: 'Order Success', isUpsell: true });
          })
      }
    }
    // Get shipping information from storage
    if (this.isShippingAvailable) {
      if (this.state.shippingInfo) {
        this.productsForShipping = this.state.shippingInfo.productsForShipping ?? [];
        this.isShippingValid = this.state.shippingInfo.isValid;
        this.accountInfoForShipping = this.state.shippingInfo.accountInfoForShipping;
        this.selectedDeliveryDay = this.state.shippingInfo.selectedDeliveryDay;
      } else {
        this.isShippingValid = false;
      }
    }
    if (this.taxServiceEnabled) {
      if (this.state.taxData) {
        this.isTaxValid = this.state.taxData.isValid ?? false;
      }
    }

    this.orderDetailsInfo = this.state.orderDetails;

    return this.tcrApi.getCountries().toPromise() //Get map of countries
      .then(async (countries:any) => {
        if (countries.length === 0) {
          console.log('getting a backup static copy of the country state payload');
          countries = await this.tcrApi.getCountriesDefault().toPromise();
        }

        if (countries) {
          countries.forEach((country:any) => {
            (this.countries as any)[country.label] = country;
          });
        }
      })
      .then(async () => {
        (window as any)['CheckoutBasePlaceOrder'] = { changePlaceOrder: this.changePlaceOrder.bind(this), zone: this.ngZone };
        (window as any)['buttonList'] = { buttonList: this.buttonList, zone: this.ngZone };
        (window as any)['upsellInfo'] = { isUpsell: true, zone: this.ngZone };
        return Promise.reject({
          allOk: true,
        });
      })
      .catch(async (error:any) => {
        await this.spinner.disable();
        await this.setData();
        if (!error.allOk) {
          console.log('Error', error);
          this.toastCtrl.create({ message: `Error! ${error.message}`, position: 'top', showCloseButton: true, cssClass: 'errorToast' })//.present();
        }
      })

  }

  async setData() {
    let paymentInProcess = false;
    if (!this.orderDetailsInfo.navParams) {
      this.orderDetailsInfo.navParams = {};
    }

    this.orderDetailsInfo.navParams.order = this.orderDetailsInfo.order;
    this.order = this.orderDetailsInfo.order;
    this.orderDetailsInfo.navParams.upsells = this.orderDetailsInfo.upsells;
    this.purchasedUpsells = this.orderDetailsInfo.purchasedUpsells || [];

    this.upsellIndex =
      this.orderDetailsInfo.upsellIndex === undefined ? -1 : this.orderDetailsInfo.upsellIndex;

    if (!this.orderDetailsInfo.navParams.paymentMethod && !this.urlParameters['resultCode']) {
      this.upsellIndex--;
    }

    this.orderDetailsInfo.navParams.paymentMethod = this.orderDetailsInfo.paymentMethod;
    this.isAmazon = this.orderDetailsInfo.paymentMethod === 'amazon';

    if (this.urlParameters['paypal'] || this.urlParameters['paypalnvp']) {
      paymentInProcess = true;
      this.orderDetailsInfo.navParams.paymentMethod = 'PayPal';
      if (this.urlParameters['action'] === 'execute') {
        if (this.urlParameters['paypalnvp']) {
          this.executePayPalNVP(this.urlParameters, this.purchasedUpsells[this.purchasedUpsells.length - 1]);
        } else {
          this.executePayPalPayment(this.urlParameters);
        }
      } else if (this.urlParameters['action'] === 'cancel') {
        let cancelOrder = this.purchasedUpsells.pop();
        this.paypalPayment.cancelPayment(cancelOrder.id).then(
          (result: any) => {
            if (result.message === 'success') {
              this.analyticsService.sendCustomEvent(`ORDER CANCELLED!`, { initTimer: this.initTimer, scrollEvents: this.scrollEvents });

              this.toastCtrl
                .create({ message: `ORDER CANCELLED!`, duration: 3000, position: 'top' })
                //.present();
            }
          },
          () => {
            this.analyticsService.sendCustomEvent(`Error on cancelling order!`, { initTimer: this.initTimer, scrollEvents: this.scrollEvents });

            this.toastCtrl
              .create({ message: `Error on cancelling order!`, duration: 3000, position: 'top' })
             // .present();
          },
        );
      }
      return;
    }

    if (this.orderDetailsInfo.navParams.upsells && this.orderDetailsInfo.navParams.order) {
      if (this.orderDetailsInfo.navParams.paymentMethod === 'Standard')
        this.paymentMethod.standard = true;

      if (this.orderDetailsInfo.navParams.paymentMethod === 'PayPal')
        this.paymentMethod.paypal = true;
      this.order = this.orderDetailsInfo.navParams.order;
      if (
        this.orderDetailsInfo.navParams.upsells &&
        this.orderDetailsInfo.navParams.upsells.length > 0
      ) {
        [this.upsell] = this.orderDetailsInfo.navParams.upsells;
      }
      if (this.taxServiceEnabled) this.showNext(false);
      if (!this.taxServiceEnabled) this.calculateTransactionFee();
    } else {
      const params: any = await this.funnelProvider.getPageByStep('first');
      if (!params) {
        return this.navCtrl.setRootExt('Home', { name: 'Home' });
      }
      const { component } = params;
      return this.navCtrl.pushExt(component.name, { name: component.name }).then(() => {
        return this.navCtrl.clearStack();
      });
    }

    console.log('[GH] currency setup : this.orderDetailsInfo', this.orderDetailsInfo);
    if (this.orderDetailsInfo.navParams.paymentMethod.startsWith ('Braintree ')) {  // TOUC-14710
      if(this.orderDetailsInfo.cr && this.orderDetailsInfo.order.crv) {
        if(this.orderDetailsInfo.cr != this.orderDetailsInfo.order.crv) {
          console.log('[GH] currency conversion rate changed');
          return this.navCtrl.setRootExt(this.stateProvider.ORDER_SUCCESS, { name: 'Order Success', isUpsell: true });
        }
      }
      this.braintreeCurrencyConversion = parseFloat(this.orderDetailsInfo.order.crv);
      console.log('[GH] Braintree currency conversion rate: ' + this.braintreeCurrencyConversion);
      if(sessionStorage.getItem('currency')) (this.currency as any) = sessionStorage.getItem('currency');
      if(sessionStorage.getItem('currencySymbol')) (this.currencySymbol as any) = sessionStorage.getItem('currencySymbol');
      this.setBraintree(this.braintreeCurrencyConversion, this.currencySymbol);

      this.braintreeCurrencyConversion = parseFloat(this.orderDetailsInfo.order.crv);
      console.log('[GH] Braintree currency conversion rate: ' + this.braintreeCurrencyConversion);
      if(sessionStorage.getItem('currency')) (this.currency as any) = sessionStorage.getItem('currency');
      if(sessionStorage.getItem('currencySymbol')) (this.currencySymbol as any) = sessionStorage.getItem('currencySymbol');
      this.setBraintree(this.braintreeCurrencyConversion, this.currencySymbol);

      this.paymentMethod.braintreeMethod = true;
      this.currency = this.orderDetailsInfo.navParams.paymentMethod.replace(
        'Braintree ', ''
      );
      if(sessionStorage.getItem('currency')) (this.currency as any) = sessionStorage.getItem('currency');
      if(sessionStorage.getItem('currencySymbol')) (this.currencySymbol as any) = sessionStorage.getItem('currencySymbol');

      console.log('[GH] this upsell', this.upsell);
      console.log('[GH] this currency', this.currency);
      console.log('[GH] this currency symbol', this.currencySymbol);
    }

    this.populatePageData();

    setTimeout(() => {
      try {
        // listen to known navigation events, control what beforeunload handler does
        let links = document.getElementsByTagName('a');
        for (let lc = 0; lc < links.length; lc++) {
          window.addEventListener('click', (event) => {
            this.plannedNav = true;
            setTimeout(() => {
              this.plannedNav = false;
            }, 300);
          });
        }
      } catch (e) {
        console.log('error ' + e);
      }
    }, 1); // TOUC-1243

    // Pixel
    this.pixelService.appendPixel(this.orderDetailsInfo);
    console.log('this.navParams', this.navParams);
    console.log('this.orderDetailsInfo', this.orderDetailsInfo);
    console.log('this.orderDetailsInfo.navParams', this.orderDetailsInfo.navParams);
    // TODO figure out the format of this data object
    //if (!this.navParams.data.isUpsell && !paymentInProcess) {
      this.generalProvider.disableBackButton();
    //}
  return;
  }

  // Global product
  setProductData() {
    // Global
    let product = this.upsell && this.upsell.product ? this.upsell.product : {};
    this.productBrand = product.productBrand && product.productBrand.uniqueName ? product.productBrand.uniqueName : '';
    this.productTitle = product.name ? product.name : '';
    // Per ticket DEV-23925, we fetch now displayOrder = 2 imageUrl, and if not found, we just proceed with the default logic
    const displayOrder2Image = product?.image.find((img: any) => img.displayOrder === 2);
    const displayOrder1Image = product?.image.find((img: any) => img.displayOrder === 1);
    this.productImage = displayOrder2Image ? displayOrder2Image.imageUrl : displayOrder1Image?.imageUrl || product?.image[0]?.imageUrl;

    // Product
    this.productRegularPrice = this.upsell.standardPrice || 0;
    this.productYourPrice = this.upsell.offerPrice || 0;
    this.productInstantSavings = this.productRegularPrice - this.productYourPrice;
    this.productPercent = Math.floor(this.productInstantSavings * 100 / this.productRegularPrice) || 0;

    this.product_box_yourPriceText = 'Your Price';
    this.product_box_instantSavingsText = 'Instant Savings';
    this.product_box_regularText = 'Regular Price'
  }

    // Slider event handlers
  onSliderChange(slideIndex: any, content: any) {
    console.log('Slider changed to slide:', slideIndex, 'for content:', content);
    // Add any slider change logic here
  }

  onSliderPrevious(slideIndex: any, content: any) {
    console.log('Slider previous clicked, current slide:', slideIndex, 'for content:', content);
    // Add any previous slide logic here
  }

  onSliderNext(slideIndex: any, content: any) {
    console.log('Slider next clicked, current slide:', slideIndex, 'for content:', content);
    // Add any next slide logic here
  }
}

interface IPageContentBase {
  name: string;
  type: string;
  componentName?: any;
  html?: any;
  options?: any;
  class?: string;
}

interface IComponentPageContent extends IPageContentBase {
  componentName: string;
  options: any;
}

interface IHTMLPageContent extends IPageContentBase {
  html: string;
}

interface IVidalytics {
  vidalyticsEmbedId: string;
  vidalyticsEmbedIdMobile: string;
}

type IPageContent = IComponentPageContent | IHTMLPageContent;
